import React from 'react';
var MENU_DOT_RADIUS = 2;
var MENU_BUTTON_PADDING = 20;
var MENU_CLICK_CONTAINER_WIDTH = 20;
var MENU_CLICK_CONTAINER_HEIGHT = 30;
var NodeMenuButton = function (_a) {
    var buttonColor = _a.buttonColor, nodeWidth = _a.nodeWidth, onClick = _a.onClick;
    var xPosition = (nodeWidth / 2) - MENU_BUTTON_PADDING;
    return (React.createElement("g", { className: 'interactiveNode__menuButton', transform: 'translate(' + xPosition + ',0)' },
        React.createElement("circle", { fill: buttonColor, r: MENU_DOT_RADIUS, cy: MENU_DOT_RADIUS * 3 }),
        React.createElement("circle", { fill: buttonColor, r: MENU_DOT_RADIUS }),
        React.createElement("circle", { fill: buttonColor, r: MENU_DOT_RADIUS, cy: MENU_DOT_RADIUS * -3 }),
        React.createElement("rect", { width: MENU_CLICK_CONTAINER_WIDTH, height: MENU_CLICK_CONTAINER_HEIGHT, x: MENU_CLICK_CONTAINER_WIDTH * -0.5, y: MENU_CLICK_CONTAINER_HEIGHT * -0.5, onClick: onClick })));
};
export default NodeMenuButton;
//# sourceMappingURL=NodeMenuButton.js.map